import { Flex } from '@mantine/core';
import { useMediaQueryGs } from 'app/hooks/useMediaQuery';
import { Colors, Text, Typography } from 'goalsetter-webapp-components';
import { breakWordStyle, fontWeightNormal, wrapperStyle } from './styles';
import { t } from 'i18next';

interface FirstFlipProps {
  whoIsCardFor?: string;
}

export const FirstFlip: React.FC<FirstFlipProps> = ({ whoIsCardFor }) => {
  const { isMobile } = useMediaQueryGs();
  return (
    <Flex
      align="baseline"
      justify="center"
      gap="xs"
      style={wrapperStyle(isMobile)}
    >
      <Text
        type={Typography.GSH5}
        color={Colors.WHITE}
        style={fontWeightNormal}
      >
        {t('animatedGoalCard.goalcardTo')}
      </Text>
      <Text
        type={Typography.GSH5}
        color={Colors.WHITE}
        style={breakWordStyle(isMobile)}
      >
        {whoIsCardFor?.toLowerCase() || '-'}
      </Text>
    </Flex>
  );
};
